module.exports = __webpack_public_path__ + "img/Zhao.4cabdbea.jpg";